import { Injectable, inject, isDevMode } from '@angular/core';
import { ORG_ID } from '@data-access/bulk-operations-api';
import { LDClient, initialize } from 'launchdarkly-js-client-sdk';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { LD_CLIENT_SIDE_ID } from '../feature-flag.module';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private ldClient: LDClient;

  constructor() {
    const clientSideId = inject(LD_CLIENT_SIDE_ID, { optional: true });
    const orgId = inject(ORG_ID, { optional: true });

    let ldClientSideId = clientSideId;
    if (isDevMode() && !ldClientSideId) {
      ldClientSideId = 'non-empty-id';
    }
    this.ldClient = initialize(ldClientSideId, { kind: 'org', key: orgId ?? 'Default' });
  }

  getFlagValue(flagName: string, defaultValue = false): Observable<boolean> {
    return from(this.ldClient.waitUntilReady()).pipe(
      map(() => this.ldClient.variation(flagName, defaultValue)),
    );
  }

  getJsonFlagValue<T>(flagName: string, defaultValue: T): Observable<T> {
    return from(this.ldClient.waitUntilReady()).pipe(
      map(() => this.ldClient.variation(flagName, defaultValue) as T),
    );
  }
}
